export enum PageTypeEnum {
  Roundup = 'Roundup',
  PaidRoundup = 'PaidRoundup',
  Review = 'Review',
  Calculator = 'Calculator',
}

export enum RoundupTypeEnum {
  MARKETING_ROUNDUP = 'MARKETING_ROUNDUP',
  ORGANIC_ROUNDUP = 'ORGANIC_ROUNDUP',
}

export enum CategoryIdsEnum {
  BANKING = '1575',
}

export enum WPEntityTypeEnum {
  OFFERS = 'offers',
  INSTITUTIONS = 'institutions',
}
